<template>
  <b-navbar toggleable="lg" type="dark" variant="primary">
     <b-navbar-brand href="#">
      <img src="@/assets/images/logos/discovery_logo.png" class=" navbar-brand-img d-none d-md-inline-flex align-top">
      <img src="@/assets/images/logos/discovery_icon.png" class="d-inline-flex d-sm-none  align-top">
    </b-navbar-brand>
      <span class="d-inline-flex flex-wrap top-text">Unlock the future of banking.<strong class="ml-1">Now</strong>.</span>


    <b-navbar-toggle target="nav-collapse" ></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
          <b-button size="sm" class="my-2 my-sm-0 text-white outline-header-button" type="submit" variant="outline-primary" href="https://www.discovery.co.za/bank/join-discovery-bank" target="_blank">Join Discovery Bank</b-button>
       
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {

}
</script>

<style scoped>
.outline-header-button{
  border-color: white;
  border: 1px solid white i !important;
}
.outline-header-button:hover{
  border-color: white;
  border: 1px solid white i !important;
  background-color: rgba(255, 255, 255, 0.1);
}

</style>